import React from 'react';
import { Mesh, Vector3 } from 'three';

import { RaycastOrder } from '@paragon/three-shared';

import { useAppDispatch } from '../components/hooks';
import { requestContextMenu } from '../store/actions/contextMenuActions';
import { resetSelectedItems } from '../store/actions/selectActions';

const point = new Vector3();

export function NullMenuTarget() {
  const dispatch = useAppDispatch();

  return (
    <mesh
      userData-raycastOrder={RaycastOrder.Nothing}
      raycast={function raycast(this: Mesh, _, intersects) {
        intersects.push({ object: this, point, distance: 0 });
      }}
      onContextMenu={(event) => {
        dispatch(resetSelectedItems());
        dispatch(requestContextMenu(event, { type: null }));
      }}
    />
  );
}
